<template>
    <div 
        class="ticker" 
        :class="themeTicker" 
        @click="clickItem" 
        @mouseover="anim = false" 
        @mouseleave="anim = true"  
        @touchmove.passive="anim = false" 
        @touchend="anim = true"
    >
        <carousel 
            ref="carousel" 
            :loop="true" 
            :autoWidth="true" 
            :nav="false" 
            :dots="false" 
            :items="items" 
            :mouseDrag="true"
            :touchDrag="true"
            class="ticker-carousel"
        >
            <div v-for="(item, index) in data" :key="index" class="ticker__item" >
                <div class="ticker__title" :data-id="item.id">
                    {{ item.titleTicker || item.title }}
                </div>
                <icon-ticker />
            </div>
        </carousel>
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import iconTicker from '@/assets/img/svg/icon-ticker.svg';
import mixTickerAnim from '@/mixins/mix-ticker-anim.js'


export default {
    name: 'ticker-carousel',
    components: {
        carousel,
        iconTicker
    },
    props: {
        id: null,
        data: null,
        theme: {
            type: String,
            default: 'light'
        }
    },
    mixins: [mixTickerAnim],
    methods: {
        clickItem(event) {
            const elem = event.target.closest('[data-id]')
            if (elem) {
                const id = elem.dataset.id
                const item = this.data.find((item) => {return item.id == id })      
                this.classUpdated(id)    
                this.$emit('getItem', {item})
            }
        },
        classUpdated(id) {
            this.$el.querySelectorAll(`.ticker__choice`).forEach((item) => {
                item.classList.remove('ticker__choice')
            })
            this.$el.querySelectorAll(`[data-id="${id}"]`).forEach((item) => {
                item.classList.add('ticker__choice')
            })
        },
    },
    computed: {
        themeTicker() {
            return `ticker__${this.theme}`
        },
    },
    watch: {
        id(value) {
            this.classUpdated(value)
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.id) {
                this.classUpdated(this.id)
            }
        })
    }
}
</script>